<template>
    <div class="perfil-form">
        <form @submit.prevent="submit"
            ref="registro-form-form"
            novalidate
            :class="{
                'validated': validated
            }"
            v-if="!isSubmitting">
            <div class="row perfil-tab-row">
                <div class="col-sm-6 col-md-4">
                    <div class="form-group">
                        <label for="registro-form-email">Email</label>
                        <input type="email"
                            :class="{
                                'form-control': true,
                                'is-invalid': validated && (email == '' || !isEmailValid),
                                'is-valid': validated && isEmailValid && email != ''
                            }"
                            name="email"
                            id="registro-form-email"
                            aria-describedby="emailHelp"
                            placeholder="Email"
                            required
                            autocomplete="off"
                            v-model="email">
                        <div class="invalid-feedback">Email inválido</div>
                        <div class="valid-feedback" v-if="validated && email != user.email"></div>
                    </div>
                </div>
            </div>
            <p class="text-left">
                <button class="btn btn-primary">Enviar</button>
            </p>
            <div class="perfil-alert"
                v-if="alert.visible">
                <font-awesome-icon
                    :icon="alert.icon"
                    :class="{
                        'color-orange': true,
                        spin: alert.iconSpin
                    }" />
                    {{ alert.message }}
            </div>
        </form>


        <b-modal v-model="isResponseMessageModalVisible"
        :busy="true"
        centered
        hide-footer
        title="Notificación">
        <div class="text-center alert-text-box">
            <p :class="{
                       'color-gray': isGuardados
                       }">
        {{ MessageModal }}
        </p>
        </div>
    </b-modal>


    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { randomString, isValidEmail } from "../utilities/util";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faCheck,
	faSpinner,
	faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

library.add(faCheck, faSpinner, faExclamationTriangle);

export default {
	components: {
		VueGoogleAutocomplete,
		FontAwesomeIcon,
        bModal
	},
	props: [],
	data() {
		return {
			alert: {
				message: "",
				visible: false,
				icon: "",
				iconSpin: false
			},
			id: 0,
			email: "",
			label: null,
			isSubmitting: false,
			validated: false,
            isResponseMessageModalVisible:false,
            MessageModal:"",
            isGuardados:false,
		};
	},
	computed: {
		isEmailValid() {
			return isValidEmail(this.email);
		},
		...mapGetters(["user", "portal"])
	},
	methods: {
		submit(e) {
			this.validated = true;
			let isValid = true;
			if (!this.isEmailValid) isValid = false;

			let newUserData = {
				email: this.email
			};

			if (isValid) {
				this.showAlert({
					iconSpin: true,
					message: "Procesando...",
					icon: "spinner"
				});
				this.$api
					.olvido_password(newUserData)
					.then(response => {
						console.log(response.data);
						if (response.data.response != "200") {

							this.showModalAlert( true, "Error al enviar correo...",false);

							setTimeout(() => {
								this.$router.push({
									name: "olvido_password"
								});
							}, 3000);

						} else {
							this.showModalAlert(true,"Correo enviado con exito...",true);

							setTimeout(() => {
								this.$router.push({
									name: "home"
								});
							}, 3000);
						}
					})
					.catch(error => {
						this.showModalAlert(true, "Error al enviar correo...",false);

						setTimeout(() => {
							this.$router.push({
								name: "olvido_password"
							});
						}, 3000);
					});
			}
		},
        showModalAlert(visible_alert,mensaje,guardar){

            this.isResponseMessageModalVisible=visible_alert;
            this.MessageModal=mensaje;
            this.isGuardados=guardar;

            setTimeout(() => {
                this.isResponseMessageModalVisible=false;
				}, 2000);

        },
		showAlert(options, autoHide) {
			this.alert.visible = true;
			this.alert = Object.assign(this.alert, options);
			if (autoHide)
				setTimeout(() => {
					this.alert.visible = false;
				}, 3000);
		}
	}
};
</script>
